import axios from 'axios';

// Subcontractor relationships + per-case sharing.
const BASE = `${process.env.REACT_APP_SERVER}subcontractors`;
const cfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function getSubcontractorLinks(token) {
  const { data } = await axios.get(BASE, cfg(token));
  return data.links || [];
}
export async function inviteSubcontractor(token, payload) {
  const { data } = await axios.post(`${BASE}/invite`, payload, cfg(token));
  return data.link;
}
export async function acceptSubcontractor(token, id) {
  const { data } = await axios.post(`${BASE}/${id}/accept`, {}, cfg(token));
  return data.link;
}
export async function declineSubcontractor(token, id) {
  const { data } = await axios.post(`${BASE}/${id}/decline`, {}, cfg(token));
  return data;
}
// Share ONE case/user with a linked subcontractor.
export async function shareCaseWithSubcontractor(token, threadId, subcontractorExpertId) {
  const { data } = await axios.post(`${BASE}/share`, { threadId, subcontractorExpertId }, cfg(token));
  return data.grant;
}
export async function getCaseShares(token, threadId) {
  const { data } = await axios.get(`${BASE}/case/${encodeURIComponent(threadId)}/shares`, cfg(token));
  return data.shares || [];
}
export async function revokeSharedCase(token, grantId) {
  const { data } = await axios.post(`${BASE}/share/${grantId}/revoke`, {}, cfg(token));
  return data;
}
